import { Introduction } from '@components/introduction';
import { useFragment } from 'react-relay';
import { fundsIntroductionFragment } from './FundsIntroduction.relay';
import type { FundsIntroductionPropsType } from './types';

const FundsIntroduction: React.FC<FundsIntroductionPropsType> = (props: FundsIntroductionPropsType) => {
  const component = useFragment(fundsIntroductionFragment, props.component);

  return <Introduction component={component} nonBreakingTitleBraces={true} />;
};

export { FundsIntroduction };
